// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-alert-modal .ant-modal-mask {
  background-color: rgba(0, 0, 0, 0.15) !important;
}

.login-alert-modal .ant-modal-content {
  box-shadow: none !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/modal/login-alert/LoginAlerts.css"],"names":[],"mappings":"AAAA;EACE,gDAAgD;AAClD;;AAEA;EACE,2BAA2B;AAC7B","sourcesContent":[".login-alert-modal .ant-modal-mask {\n  background-color: rgba(0, 0, 0, 0.15) !important;\n}\n\n.login-alert-modal .ant-modal-content {\n  box-shadow: none !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
